class SavingsDisplayCtrl {
  static bindings = {
    savings: '='
  };

  savings;

  savingsClass() {
    if (this.savings == null) {
      // $scope.savingsDisplayValue = 'N/A';
      return 'savings-tab-na-saving';
    } else if (this.savings >= 0) {
      return 'savings-tab-saving';
    } else {
      return 'savings-tab-not-saving';
    }
  }
}

export const SavingsDisplayComponent = {
  bindings: SavingsDisplayCtrl.bindings,
  controller: SavingsDisplayCtrl,
  template: `<div class="savings-tab" ng-class="$ctrl.savingsClass()">
      <div class="savings-percent" ng-if="$ctrl.savings != null">{{ $ctrl.savings | percentage }}</div>
      <div class="savings-percent" ng-if="$ctrl.savings == null">N/A</div>
    </div>`
};
